import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CRMAtividade } from 'src/app/models/crm/crmatividade';
import { globals } from 'src/app/globals';

@Injectable({
  providedIn: 'root'
})
export class CrmatividadeService {

  constructor(private http: HttpClient) { }

  consultarAtividadesComFiltro(filtro) {
    return this.http.post<CRMAtividade[]>(globals.apiUrl + '/api/CRMAtividade/ListaComFiltro', filtro);
  }

  consultarAtividades() {
    return this.http.get<CRMAtividade[]>(globals.apiUrl + '/api/CRMAtividade/Lista');
  }

  consultarAtividadesPorOportunidade(idOportunidade) {
    return this.http.get<CRMAtividade[]>(globals.apiUrl + '/api/CRMAtividade/ListaPorOportunidade',
     {
       params: new HttpParams().set('id', idOportunidade)
     });
  }

  consultarPorIdAtividade(idAtividade) {
    return this.http.get<any>(globals.apiUrl + '/api/CRMAtividade/Buscar',
      { params: new HttpParams().set('id', idAtividade) });
  }

  salvar(atividade: CRMAtividade) {
    return this.http.post(globals.apiUrl + '/api/CRMAtividade/Salvar', atividade);
  }

  alterarStatus(atividade: CRMAtividade) {
    return this.http.post(globals.apiUrl + '/api/CRMAtividade/AlterarStatus', atividade);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/CRMAtividade/Excluir',
      { params: new HttpParams().set('id', id) });
  }

  enviarAlertas() {
    return this.http.get(globals.apiUrl + '/api/CRMAtividade/EnviarAlertas');
  }

  trocarUsuario(transferencias) {
    return this.http.post(globals.apiUrl + '/api/CRMAtividade/TrocarUsuario', transferencias);
  }
}